import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: apiServices.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { AbVersionInfoFactory } from "absdk/commons/api/dto/AbVersionInfo";
// @ts-ignore noUnusedLocals
import { ExpExpressionDefinitionFactory } from "../dto/ExpExpressionDefinition";
// @ts-ignore noUnusedLocals
import { ExpExpressionDefinitionSaveRequestFactory } from "../dto/ExpExpressionDefinitionSaveRequest";
// @ts-ignore noUnusedLocals
import { ExpExpressionDomainFactory } from "../dto/ExpExpressionDomain";
// @ts-ignore noUnusedLocals
import { ExpGloballyUniqueExpressionIDFactory } from "../dto/ExpGloballyUniqueExpressionID";
// @ts-ignore noUnusedLocals

// @ts-ignore noUnusedLocals
import { ExpLiveViewSliceFactory } from "../dto/ExpLiveViewSlice";
// @ts-ignore noUnusedLocals

// @ts-ignore noUnusedLocals

import { AbWebServices } from "abweb/service/AbWebServices";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { StringUtils } from "abweb/utils/StringUtils";
import { URLUtils } from "abweb/utils/URLUtils";
import { ProxyRPCService } from "abweb/service/rpc/ProxyRPCService";
import { ProxyType } from "abweb/dto/generated/proxy/ProxyType";

// @ts-ignore noUnusedLocals

// @ts-ignore noUnusedLocals

export class ExpressionApiServices {
  static initDefaultServices() {
    ExpressionApiServices.buildApiService(AbWebServices.getRPCService(), "", true, true);
  }
  static initProxyServices() {
    return ProxyRPCService.registerRPCServices(ProxyType.ENTITY, (rpcService, proxyServiceInfo) => {
      ExpressionApiServices.buildApiService(rpcService, proxyServiceInfo.label, proxyServiceInfo.isDefault);
    });
  }
  static buildApiService(rpcService, proxyLabel, isDefault, isLocal = false) {
    if (ExpressionApiServices.serviceMap.has(proxyLabel)) {
      ExpressionApiServices.LOG.warn("Already initialized ExpressionApiServices. Call resetServices before re-initializing.");
    }
    proxyLabel = StringUtils.emptyIfNull(proxyLabel);
    const expressionApi = new ExpressionApiInvoker(rpcService);
    ExpressionApiServices.serviceMap.set(proxyLabel, expressionApi);

    // If the service is considered "default" and the proxyLabel is not "" you would
    // usually also set it as the service identified by the empty label. However,
    // we know that it is possible that an application may want to host non-proxied services
    // in addition to proxied ones. In that case, DO NOT clear out the native service
    // that is already stored with the empty label.
    if (isLocal || isDefault && proxyLabel !== "" && ExpressionApiServices.serviceMap.get("") == null) {
      ExpressionApiServices.serviceMap.set("", expressionApi);
    }
    return expressionApi;
  }
  static getExpressionApi(proxyLabel) {
    proxyLabel = StringUtils.emptyIfNull2(proxyLabel);
    let services = ExpressionApiServices.serviceMap.get(proxyLabel);
    if (!services) {
      ExpressionApiServices.initProxyServices();
      services = ExpressionApiServices.serviceMap.get(proxyLabel);
      if (!services) {
        throw new Error(`No proxy service found for proxy label '${proxyLabel}'`);
      }
    }
    return services;
  }
  static resetServices() {
    ExpressionApiServices.serviceMap.clear();
  }
}
_defineProperty(ExpressionApiServices, "LOG", LogUtils.getLogger("ExpressionApiServices"));
_defineProperty(ExpressionApiServices, "serviceMap", new Map());
class ExpressionApiInvoker {
  constructor(rpcService) {
    _defineProperty(this, "rpcService", void 0);
    this.rpcService = rpcService;
  }
  async closeHandle(handle) {
    if (handle === null || handle === undefined) {
      throw new Error("Required parameter handle was null or undefined when calling closeHandle.");
    }
    const parameters = {};
    const handleParam = "handle";
    parameters[handleParam] = handle;
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/{handle}/actions/close", parameters);
    await this.rpcService.invokeVoid(invokeUrl, null, {
      method: "POST".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
  }
  async getDomainForContext(handle) {
    if (handle === null || handle === undefined) {
      throw new Error("Required parameter handle was null or undefined when calling getDomainForContext.");
    }
    const parameters = {};
    const handleParam = "handle";
    parameters[handleParam] = handle;
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/{handle}/domain", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = ExpExpressionDomainFactory.FromJSON(response);
    return responseObject;
  }
  async getExpressionDefinition(handle) {
    if (handle === null || handle === undefined) {
      throw new Error("Required parameter handle was null or undefined when calling getExpressionDefinition.");
    }
    const parameters = {};
    const handleParam = "handle";
    parameters[handleParam] = handle;
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/{handle}/definition", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = ExpExpressionDefinitionFactory.FromJSON(response);
    return responseObject;
  }
  async getExpressionDomain(domainID) {
    if (domainID === null || domainID === undefined) {
      throw new Error("Required parameter domainID was null or undefined when calling getExpressionDomain.");
    }
    const parameters = {};
    const domainIDParam = "domainID";
    if (domainID !== undefined) {
      parameters[domainIDParam] = domainID;
    }
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/domain", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = ExpExpressionDomainFactory.FromJSON(response);
    return responseObject;
  }
  async getSupportedDomainIDs() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/domainIDs", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    return response;
  }
  async getVersionInfo() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/version", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = AbVersionInfoFactory.FromJSON(response);
    return responseObject;
  }
  openExpressionView(fullViewHandler, updateViewHandler, handle) {
    if (handle === null || handle === undefined) {
      throw new Error("Required parameter handle was null or undefined when calling openExpressionView.");
    }
    const parameters = {};
    const handleParam = "handle";
    parameters[handleParam] = handle;
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/{handle}/view/subscribe", parameters);
    let fullProcessor = function (message) {
      fullViewHandler(message);
    };
    fullProcessor.parse = (messageJSON, dc) => {
      return ExpLiveViewSliceFactory.FromJSON(messageJSON);
    };
    let updateProcessor = function (message) {
      updateViewHandler(message);
    };
    updateProcessor.parse = (messageJSON, dc) => {
      return ExpLiveViewSliceFactory.FromJSON(messageJSON);
    };
    return this.rpcService.invokeView(invokeUrl, null, fullProcessor, updateProcessor, {
      method: "POST".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
  }
  async openHandle(expGloballyUniqueExpressionID) {
    if (expGloballyUniqueExpressionID === null || expGloballyUniqueExpressionID === undefined) {
      throw new Error("Required parameter expGloballyUniqueExpressionID was null or undefined when calling openHandle.");
    }
    const bodyParam = ExpGloballyUniqueExpressionIDFactory.ToJSON(expGloballyUniqueExpressionID);
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/actions/openHandle", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "POST".toLowerCase(),
      headers: {
        "Content-Type": contentType
      },
      body: JSON.stringify(bodyParam)
    });
    return response;
  }
  async saveExpressionDefinition(handle, expExpressionDefinitionSaveRequest) {
    if (handle === null || handle === undefined) {
      throw new Error("Required parameter handle was null or undefined when calling saveExpressionDefinition.");
    }
    if (expExpressionDefinitionSaveRequest === null || expExpressionDefinitionSaveRequest === undefined) {
      throw new Error("Required parameter expExpressionDefinitionSaveRequest was null or undefined when calling saveExpressionDefinition.");
    }
    const bodyParam = ExpExpressionDefinitionSaveRequestFactory.ToJSON(expExpressionDefinitionSaveRequest);
    const parameters = {};
    const handleParam = "handle";
    parameters[handleParam] = handle;
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/{handle}/save", parameters);
    await this.rpcService.invokeVoid(invokeUrl, null, {
      method: "POST".toLowerCase(),
      headers: {
        "Content-Type": contentType
      },
      body: JSON.stringify(bodyParam)
    });
  }
  async saveExpressionDefinitionAndReturnUpdated(handle, expExpressionDefinitionSaveRequest) {
    if (handle === null || handle === undefined) {
      throw new Error("Required parameter handle was null or undefined when calling saveExpressionDefinitionAndReturnUpdated.");
    }
    if (expExpressionDefinitionSaveRequest === null || expExpressionDefinitionSaveRequest === undefined) {
      throw new Error("Required parameter expExpressionDefinitionSaveRequest was null or undefined when calling saveExpressionDefinitionAndReturnUpdated.");
    }
    const bodyParam = ExpExpressionDefinitionSaveRequestFactory.ToJSON(expExpressionDefinitionSaveRequest);
    const parameters = {};
    const handleParam = "handle";
    parameters[handleParam] = handle;
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/expression/{handle}/saveAndReturnUpdated", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "POST".toLowerCase(),
      headers: {
        "Content-Type": contentType
      },
      body: JSON.stringify(bodyParam)
    });
    let responseObject = ExpExpressionDefinitionFactory.FromJSON(response);
    return responseObject;
  }
}
//# sourceMappingURL=ExpressionApiServices.js.map
